module.exports = {
    type: 'Complete os espaços em branco',
    instruction1: 'Digite abaixo o enunciado da questão.',
    instruction2: 'Digite a frase que deverá ser completada pelo aluno. O resultado aparecerá na caixa de texto abaixo. As palavras que aparecerão como espaços em branco (nos quais o aluno irá digitar a resposta) deverão ser delimitadas por sinais de porcentagem (%). Exemplo: Dois mais dois são %quatro%.',
    typeHere: 'Digite aqui...',
}